"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OmnitureHelper = exports.AdobeOmnitureBuilder = void 0;
var AdobeOmnitureBuilder = /** @class */ (function () {
    function AdobeOmnitureBuilder(pageName) {
        this.pageName = pageName;
        this.hitType = AdobeOmnitureBuilder.DEFAULT_VALUE;
        this.subPageName = AdobeOmnitureBuilder.DEFAULT_VALUE;
        this.pageAction = AdobeOmnitureBuilder.DEFAULT_VALUE;
        this.pageConst = AdobeOmnitureBuilder.DEFAULT_VALUE;
        this.refTag = AdobeOmnitureBuilder.DEFAULT_VALUE;
        this.referrer = AdobeOmnitureBuilder.DEFAULT_VALUE;
    }
    AdobeOmnitureBuilder.prototype.withSubPageName = function (subPageName) {
        this.subPageName = subPageName;
        return this;
    };
    AdobeOmnitureBuilder.prototype.withHitType = function (hitType) {
        this.hitType = hitType;
        return this;
    };
    AdobeOmnitureBuilder.prototype.withPageAction = function (pageAction) {
        this.pageAction = pageAction;
        return this;
    };
    AdobeOmnitureBuilder.prototype.withPageConst = function (pageConst) {
        this.pageConst = pageConst;
        return this;
    };
    AdobeOmnitureBuilder.prototype.withRefTag = function (refTag) {
        this.refTag = refTag;
        return this;
    };
    AdobeOmnitureBuilder.prototype.withReferrer = function (referrer) {
        this.referrer = referrer;
        return this;
    };
    AdobeOmnitureBuilder.prototype.build = function () {
        var prevPageName = AdobeOmnitureBuilder.prevPageName;
        AdobeOmnitureBuilder.prevPageName = this.pageName;
        return {
            pageName: this.pageName,
            eVar42: this.pageName,
            eVar43: this.pageName,
            eVar44: this.subPageName,
            eVar45: this.pageAction,
            eVar46: this.pageConst,
            eVar47: this.hitType,
            prop31: this.refTag,
            prop27: prevPageName,
            referrer: this.referrer
        };
    };
    AdobeOmnitureBuilder.DEFAULT_VALUE = '';
    return AdobeOmnitureBuilder;
}());
exports.AdobeOmnitureBuilder = AdobeOmnitureBuilder;
var OmnitureHelper = /** @class */ (function () {
    function OmnitureHelper() {
    }
    /**
     * Call Omniture to update the metrics for page information
     * @param pageInfo - omniture model
     */
    OmnitureHelper.setOmniturePageInfo = function (pageInfo) {
        if (OmnitureHelper.hasOmniture(window)) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            var omniture = window.s;
            omniture.t(pageInfo);
        }
    };
    /**
     * Determine if the current window has omniture js available
     */
    OmnitureHelper.hasOmniture = function (window) {
        return !!window.s;
    };
    return OmnitureHelper;
}());
exports.OmnitureHelper = OmnitureHelper;
